import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  standalone: false,

  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  public confirmationDesc = null;
  public validateButtonText = null;
  public cancelButtonText = null;

  constructor(
    public activeModal: NgbActiveModal,
  ) {
  }
}
